import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import TableContainer from '../../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import permissionSvg from '../../../../assets/images/svg/permission.svg'
import { numberWithCommas } from "../../../../helpers/globalHelper"
import Language from '../../../../locales/mn/translation.json'

import DeleteModal from '../../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useMenuFindAllQuery, useMenuPermissionCreateMutation, useMenuPermissionDeleteMutation, useMenuPermissionFindAllQuery, useMenuPermissionUpdateMutation } from '../../../../store';

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [permissionOne, setPermissionOne] = useState<any>(null)
  const [permissionList, setPermissionList] = useState<any>();
  const [permissionCount, setPermissionCount] = useState<any>();
  const [menuList, setMenuList] = useState<any>();

  const {
    data: permissionData,
    error: permissionError,
    isFetching: isPermissionFetching,
  } = useMenuPermissionFindAllQuery();

  const {
    data: menuData,
    error: menuError,
    isFetching: isMenuFetching,
  } = useMenuFindAllQuery();

  const [menuPermissionCreate, menuPermissionCreateResult] = useMenuPermissionCreateMutation();
  const [menuPermissionUpdate, menuPermissionUpdateResult] = useMenuPermissionUpdateMutation();
  const [menuPermissionDelete, menuPermissionDeleteResult] = useMenuPermissionDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    setPermissionList(permissionData?.data)
    setLoading(false)
    setPermissionCount(permissionList?.length)

    setMenuList(menuData?.data)

    setCustomPagination(permissionData?.pagination)
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [permissionData, permissionCount, permissionList, customPageSize, customPageLength, customPagination])


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPermissionOne(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempMenu = arg;

    setPermissionOne({
      permission_id: tempMenu.permission_id,
      menu_id: tempMenu.menu_id,
      code: tempMenu.code,
      name: tempMenu.name,
      display: tempMenu.display,
      description: tempMenu.description,
    });
    setIsEdit(true);
    toggle();
  }, []);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (selectRowData) => {
    setPermissionOne(selectRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (permissionOne) {
      menuPermissionDelete(permissionOne.permission_id)
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setPermissionOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "permission_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.permission_id}</Link>
        }
      },
      {
        header: "Меню нэр",
        accessorKey: "menu_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          const menuItem = menuData?.data.find((menu: any) => menu.menu_id === cellProps.row.original.menu_id);
          return menuItem ? (
            <Link to="#" className="text-body fw-bold">
              {Language[menuItem.name]}
            </Link>
          ) : null;
        }
      },
      {
        header: "Меню код",
        accessorKey: "menu_code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Зөвшөөрөл нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Display',
        accessorKey: "display",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Тайлбар',
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const menuData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(menuData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const selectRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(selectRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Soft delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleJobClick]
  );


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: permissionOne?.permission_id,
      menu_id: permissionOne?.menu_id,
      code: permissionOne?.code,
      name: permissionOne?.name,
      display: permissionOne?.display,
      description: permissionOne?.description,
    },
    validationSchema: Yup.object({
      menu_id: Yup.string().required("Утга оруулна уу !"),
      code: Yup.string().required("Утга оруулна уу !"),
      name: Yup.string().required("Утга оруулна уу !"),
      display: Yup.string().required("Утга оруулна уу !"),
      description: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {

      console.log(values);

      if (isEdit) {
        const updateMenuList = {
          id: permissionOne ? values.id : 0,
          menu_id: values.menu_id,
          code: values.code,
          name: values.name,
          display: values.display,
          description: values.description,
        };

        console.log(updateMenuList);


        menuPermissionUpdate(updateMenuList)
      } else {

        const newMenuList = {
          menu_id: parseInt(values["menu_id"]),
          code: values["code"],
          name: values["name"],
          display: values["display"],
          description: values["description"],
          // code: values["code"],
        };
        menuPermissionCreate(newMenuList)
      }
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={permissionOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={permissionSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(permissionCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={permissionList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Меню зөвшөөрөл засах" : "Меню зөвшөөрөл нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label> Меню нэр </Label>
                  <Input
                    name="menu_id"
                    type="select"
                    className="form-select"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.menu_id || ""}
                    invalid={
                      validation.touched.menu_id && validation.errors.menu_id ? true : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {menuList?.map((item, index) => (
                      <option key={index} value={item?.menu_id}>
                        {item?.menu_id} :: {Language[item?.name]}
                      </option>
                    ))}
                  </Input>

                  {validation.touched.menu_id && validation.errors.menu_id ? (
                    <FormFeedback type="invalid">{validation.errors.menu_id}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label> Код </Label>
                  <Input
                    name="code"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code && validation.errors.code ? true : false
                    }
                  />
                  {validation.touched.code && validation.errors.code ? (
                    <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label> Нэр </Label>
                  <Input
                    name="name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label> Display </Label>
                  <Input
                    name="display"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.display || ""}
                    invalid={
                      validation.touched.display && validation.errors.display ? true : false
                    }
                  />
                  {validation.touched.display && validation.errors.display ? (
                    <FormFeedback type="invalid">{validation.errors.display}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label> Тайлбар </Label>
                  <Input
                    name="description"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.description || ""}
                    invalid={
                      validation.touched.description && validation.errors.description ? true : false
                    }
                  />
                  {validation.touched.description && validation.errors.description ? (
                    <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Save</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;